$(function() {
  $('[data-id="featured-article-template"].featured').on('mouseover', function() {
    $('.featured-excerpt', this).addClass('show');
  });

  $('[data-id="featured-article-template"].featured').on('mouseout', function() {
    $('.featured-excerpt', this).removeClass('show');
  });
})
